import React from "react";
import Logo from "../assets/logo.png";

const NotFoundPage: React.FC = () => {
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
            <div className="max-w-4xl flex flex-col md:flex-row items-center bg-white rounded-2xl shadow-xl p-6 md:p-12 animate-fadeIn">

                {/* Left Side - Text & Animated 404 */}
                <div className="flex-1 text-center md:text-left">
                    <h1 className="text-7xl md:text-8xl font-extrabold text-gray-900 animate-bounce">404</h1>
                    <h2 className="text-3xl md:text-4xl text-gray-600 mt-4">Oops! Page Not Found</h2>
                    <p className="text-gray-500 mt-2">
                        The page you are looking for might have been removed or is temporarily unavailable.
                    </p>
                    <a
                        href="https://app.williamscourthotel.com"
                        className="inline-block mt-6 px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform duration-300 shadow-md"
                        rel="noopener noreferrer" // security best practice
                    >
                        Go Back Home
                    </a>

                </div>

                {/* Right Side - Logo */}
                <div className="flex-1 mt-8 md:mt-0 md:ml-8 flex justify-center">
                    <img
                        src={Logo}
                        alt="Wiventory Logo"
                        className="h-36 md:h-48 rounded-xl shadow-lg"
                    />
                </div>
            </div>

            {/* Tailwind Animations */}
            <style>
                {`
          @keyframes fadeIn {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }

          .animate-fadeIn {
            animation: fadeIn 0.8s ease-out forwards;
          }

          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }

          .animate-bounce {
            animation: bounce 1.5s infinite;
          }
        `}
            </style>
        </div>
    );
};

export default NotFoundPage;
